import {Fragment} from 'react';

import {TransferLogs} from '../component/TransferLogs';

export default function ThongBaoSaiSot() {

  return (
    <Fragment>
      <TransferLogs type="WrongInvoice,WrongInvoiceCash"/>
    </Fragment>
  );
}
